// extracted by mini-css-extract-plugin
export default {"container":"chat_container__6Ge6a"};